import { c as color, p as palette } from '../base/color-DMp1DFwP.js';
import { a as link, t as typography } from '../base/typography-j1qfCKl5.js';
import { s as spacing, a as spacingValues } from '../base/spacing-zNVNrnl_.js';
import { f as focus } from '../base/focus-B_eJw-S_.js';
import { g as globals } from '../base/globals-KScgLNUm.js';
import { a as alert } from '../component/alert-YJFz3xiV.js';
import { b as breadcrumbs } from '../component/breadcrumb-BFSLb5RR.js';
import { b as button } from '../component/button-DzuTwMo0.js';
import { c as card } from '../component/card-m0gFjhD0.js';
import { c as checkboxStyles } from '../component/checkbox-9mCPwUIz.js';
import { c as circularProgressIndicatorStyles } from '../component/circularProgressIndicator-CgN1w_Qn.js';
import { d as datepicker } from '../component/datepicker-D-v9RfGZ.js';
import { d as dividerStyles } from '../component/divider-C7Pe4BVz.js';
import { d as dropdownStyles } from '../component/dropdown-Bu5wlgg6.js';
import { h as helptipStyles } from '../component/helptip-BP8axqu3.js';
import { i as icon } from '../component/icon-DQ43FXA3.js';
import { i as inputStyles } from '../component/input-bqcyBnEK.js';
import { l as labelStyles } from '../component/label-gn2VuZlQ.js';
import { m as modal } from '../component/modal-B7s4q_4T.js';
import { p as pagination } from '../component/pagination-Bf5FM4AC.js';
import { p as pill$1 } from '../component/pillLegacy-DGmoml8T.js';
import { p as pill } from '../component/pill-Dpiov0cX.js';
import { p as popover } from '../component/popover-CbE5lSgB.js';
import { p as portalStyles } from '../component/portal-DhH1e5-Z.js';
import { p as progressIndicatorStyles } from '../component/progressIndicator-CtMrJMZh.js';
import { r as radioStyles } from '../component/radio-DdysEhyl.js';
import { r as rangeSlider } from '../component/rangeSlider-CDtxWXr-.js';
import { s as sectionExpanderStyles } from '../component/sectionExpander-Bz2L78dr.js';
import { s as sideNavItemStyles, a as sideNavStyles } from '../component/sideNavigation-CsHE8yRE.js';
import { s as searchInputStyles } from '../component/searchInput-DQA9YiST.js';
import { s as snackbar } from '../component/snackbar-BWmrcD_2.js';
import { s as sortableListStyles } from '../component/sortableList-vCIwfpds.js';
import { s as starRatingStyles } from '../component/starRating-CbkgZbUO.js';
import { s as stepsStyles } from '../component/steps-DAG1hAL9.js';
import { s as surfaceStyles } from '../component/surface-CjDqA5Xg.js';
import { s as switchStyles } from '../component/switch-ClnqNU3i.js';
import { t as tableStyles } from '../component/table-zKa7sg3k.js';
import { t as tabNavigationStyles } from '../component/tabNavigation-CjQBNNXm.js';
import { t as tagStyles } from '../component/tag-BItIQvRd.js';
import { t as textAreaStyles } from '../component/textarea-CNkfng2a.js';
import { t as tooltip } from '../component/tooltip-BTnjpaiq.js';
import { t as touchLink } from '../component/touchLink-CzpG8W70.js';
import { t as tree } from '../component/tree-BeeBH0oq.js';
import { t as treeViewStyles } from '../component/treeView-Bk6I_a_7.js';
import { a as anchoredAlertStyles } from '../component/anchoredAlert-CUi7Yfgi.js';
import { s as secondaryView } from '../component/secondaryView-Dmb5CGIK.js';
import { s as splitButton } from '../component/splitButton-pw-eLS1y.js';
import { p as peekabooStickyTab } from '../component/peekabooStickyTab-Dmoxx5Ky.js';
import { p as pageLayout } from '../component/pageLayout-CjtHtK76.js';
import { s as surfaceDarkStyles } from '../component/surfaceDark-CjzXgz54.js';
import { s as surfaceDarkInfoStyles } from '../component/surfaceDarkInfo-nak4bJe3.js';
import { s as surfaceLightStyles } from '../component/surfaceLight-DGLrbQeB.js';

const theme = {
  pageLayout,
  palette,
  spacingValues,
  spacing,
  globals,
  color,
  typography,
  breadcrumbs,
  button: button,
  card,
  divider: dividerStyles,
  dropdown: dropdownStyles,
  form: {
    label: labelStyles,
    input: inputStyles,
    textarea: textAreaStyles,
    search: searchInputStyles,
    checkbox: checkboxStyles,
    radio: radioStyles
  },
  icon,
  message: alert,
  modal,
  navigation: {
    tabs: tabNavigationStyles
  },
  pagination: pagination,
  pillLegacy: pill$1,
  pillv2Beta: pill,
  // adding in for TropicalUI support, which references this theme value
  pill: pill,
  popover: popover,
  portal: portalStyles,
  switch: switchStyles,
  tooltip,
  helptip: helptipStyles,
  datepicker,
  starRating: starRatingStyles,
  sortableList: sortableListStyles,
  sideNav: sideNavStyles,
  sideNavItem: sideNavItemStyles,
  surface: surfaceStyles,
  surfaceLight: surfaceLightStyles,
  surfaceDark: surfaceDarkStyles,
  surfaceDarkInfo: surfaceDarkInfoStyles,
  rangeSlider,
  table: tableStyles,
  tree,
  treeView: treeViewStyles,
  sectionExpander: sectionExpanderStyles,
  tag: tagStyles,
  touchLink,
  steps: stepsStyles,
  focusVisible: focus,
  progressIndicator: progressIndicatorStyles,
  circularProgressIndicator: circularProgressIndicatorStyles,
  snackbar,
  anchoredAlert: anchoredAlertStyles,
  link,
  secondaryView,
  splitButton,
  peekabooStickyTab
};

export { theme as t };
//# sourceMappingURL=default-DiOFom7y.js.map
